module.exports = __webpack_public_path__ + "static/media/chocolateChunk.13421436.png";